import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'lyceo-page-header',
  imports: [FaIconComponent],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  public readonly title: InputSignal<string> = input.required();
  public readonly subTitle: InputSignal<string | undefined> = input();
  public readonly logo: InputSignal<boolean> = input(false);
  public readonly backButton: InputSignal<boolean> = input(false);
  public readonly backButtonClicked: OutputEmitterRef<void> = output();

  protected readonly faChevronLeft: IconDefinition = faChevronLeft;
}
